import "core-js/modules/es.symbol";
import "core-js/modules/es.symbol.description";
import "core-js/modules/es.symbol.iterator";
import "core-js/modules/es.array.iterator";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.regexp.to-string";
import "core-js/modules/es.string.iterator";
import "core-js/modules/es.string.link";
import "core-js/modules/web.dom-collections.iterator";

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) { return; } var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import React, { useState } from "react";
import CookieReadMoreModal from "web/react/components/cookie-read-more-modal/cookie-read-more-modal";
import Checkbox from "web/react/components/checkbox/checkbox";
import { gettext } from "web/script/modules/django-i18n";
import classnames from "classnames";
import styles from "./cookie-settings-option.css";
export default function CookieSettingsOption(_ref) {
  var optionID = _ref.optionID,
      optionTitle = _ref.optionTitle,
      isEssential = _ref.isEssential,
      cookieDescription = _ref.cookieDescription,
      isSelected = _ref.isSelected,
      onChange = _ref.onChange;

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      readMoreIsOpen = _useState2[0],
      setReadMoreIsOpen = _useState2[1];

  function openReadMore() {
    setReadMoreIsOpen(true);
  }

  function closeReadMore() {
    setReadMoreIsOpen(false);
  }

  var cookieStatusFragment;

  if (isEssential) {
    cookieStatusFragment = React.createElement("div", {
      className: styles.cookieStatus
    }, gettext("cookie_notification.cookie_settings.required_always_on.label"));
  } else {
    cookieStatusFragment = React.createElement(Checkbox, {
      elementID: optionID,
      defaultValue: isSelected,
      onChange: onChange,
      className: styles.cookieStatus
    });
  }

  return React.createElement("div", {
    className: styles.cookieOption
  }, React.createElement("div", {
    className: styles.cookieDetails
  }, React.createElement("div", {
    className: styles.cookieTitle
  }, optionTitle), cookieStatusFragment), React.createElement("a", {
    className: classnames(styles.cookieReadMore, styles.link),
    onClick: openReadMore
  }, gettext("general.read_more")), React.createElement(CookieReadMoreModal, {
    isOpen: readMoreIsOpen,
    onModalClose: closeReadMore,
    title: optionTitle,
    content: cookieDescription
  }));
}